module.exports = __webpack_public_path__ + "static/img-runway-dude-04e1b5be92e96269e846e56a71b6ee0c.png";